module.exports = __webpack_public_path__ + "static/media/brand13.3bd4df6a.png";